/**
 * Dependencies
 */
import http from '../../../../../services/HttpService'

/**
 * Reset the module state
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetState = ({ commit }) => commit('RESET_STATE')

/**
 * Retrieve the lease up schedules
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Promise}
 */
const getSchedules = ({ commit, rootState }) => new Promise((resolve, reject) => {
    http.get(`projects/${rootState.route.params.projectId}/lease-up-schedules/`)
        .then(res => {
            commit('SET_DATA', res.data)
            resolve(res.data)
        })
        .catch(err => {
            commit('SET_ERROR', err.response.data)
            reject(err)
        })
})

/**
 * Create a new schedule
 *
 * @param  {Function} commit
 * @param  {Object} rootState
 * @return {Promise}
 */
const createSchedule = ({ commit, rootState }, form) => new Promise((resolve, reject) => {
    commit('RESET_ERRORS')
    http
        .post(`projects/${rootState.route.params.projectId}/lease-up-schedules/`, form)
        .then(res => {
            commit('ADD_DATA', res.data)
            resolve()
        })
        .catch(err => {
            commit('SET_ERRORS', err.response.data.steps)
            reject(err)
        })
})

export default {
    resetState,
    getSchedules,
    createSchedule
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/form/lease-up-schedules/actions.js